import { TreeNode } from "./types";

export function filterTree(
  nodes: TreeNode[],
  query: string
): TreeNode[] {
  if (!query.trim()) return nodes;

  const q = query.toLowerCase();

  const filter = (node: TreeNode): TreeNode | null => {
    const matches = node.label.toLowerCase().includes(q);

    if (!node.children) {
      return matches ? node : null;
    }

    const filteredChildren = node.children
      .map(filter)
      .filter(Boolean) as TreeNode[];

    if (matches || filteredChildren.length > 0) {
      return {
        ...node,
        children: filteredChildren
      };
    }

    return null;
  };

  return nodes
    .map(filter)
    .filter(Boolean) as TreeNode[];
}